import React from 'react';
import { Row } from 'reactstrap';
import DonutContainer from 'components/containers/DonutContainer';
import HorizontalBarChartContainer from 'components/containers/HorizontalBarChartContainer';
import ScreenTransitionContainer from 'components/containers/ScreenTransitionContainer';

let page = 'portal';
let displayPageName = 'Portal';

class PortalNavigationOverview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    async componentDidUpdate(prevProps, prevState) {}

    async componentDidMount() {}

    render() {
        let dashboard = (
            <div>
                <Row>
                    <DonutContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        forceReloadAll={this.props.forceReloadAll}
                        renderType=""
                        donut_value="portal_device_browser"
                        page={page}
                        pageName={displayPageName}
                        tabFunction={this.props.tabFunction}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        subscription={this.props.subscription}
                        app={this.props.app}
                        subscriptionStage={this.props.subscriptionStage}
                    />

                    <DonutContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        forceReloadAll={this.props.forceReloadAll}
                        renderType=""
                        donut_value="portal_device_os"
                        page={page}
                        pageName={displayPageName}
                        tabFunction={this.props.tabFunction}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        subscription={this.props.subscription}
                        app={this.props.app}
                        subscriptionStage={this.props.subscriptionStage}
                    />
                </Row>

                <Row>
                    <DonutContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        forceReloadAll={this.props.forceReloadAll}
                        renderType=""
                        donut_value="portal_device_type"
                        page={page}
                        pageName={displayPageName}
                        tabFunction={this.props.tabFunction}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        subscription={this.props.subscription}
                        app={this.props.app}
                        subscriptionStage={this.props.subscriptionStage}
                    />

                    <HorizontalBarChartContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        usageSource="Portal"
                        forceReloadAll={this.props.forceReloadAll}
                        title="Portal Browsing Pages"
                        workbenchTitle="portal_browsing_pages"
                        page={page}
                        pageName={displayPageName}
                        reportType="pages"
                        color="#2BCAB7"
                        key="portal_overview_portal_browsing_pages_1"
                        id="portal_overview_portal_browsing_pages_1"
                        tabFunction={this.props.tabFunction}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        subscription={this.props.subscription}
                        app={this.props.app}
                        subscriptionStage={this.props.subscriptionStage}
                    />
                </Row>

                <Row>
                    <ScreenTransitionContainer
                        path={this.props.path}
                        usageSource={displayPageName}
                        pageName={displayPageName}
                        page={page}
                        forceReloadAll={this.props.forceReloadAll}
                        id={'portal_overview_screen_transition'}
                        title={'Portal Screen Transitions'}
                        appliedFilters={this.props.appliedFilters}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        subscription={this.props.subscription}
                        app={this.props.app}
                        subscriptionStage={this.props.subscriptionStage}
                    />
                </Row>
            </div>
        );

        return <div>{dashboard}</div>;
    }
}

export default PortalNavigationOverview;
